import { FC, lazy, Suspense } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentArticleAsAvailable } from '~/routes/$user_link_name_.$article_id/shared/atoms/current-article';
import { EArticleClass } from 'shared/models';
import { ArticleContentV2 } from './v2';

const ArticleContentLegacy = lazy(() => import('./legacy'));

export const ArticleContent: FC = () => {
  const article = useAtomValue($CurrentArticleAsAvailable);

  switch (article.articleClass) {
    case EArticleClass.ARTICLE:
      return (
        <Suspense>
          <ArticleContentLegacy />
        </Suspense>
      );
    case EArticleClass.GALLERY:
    case EArticleClass.VIDEO:
    default:
      return <ArticleContentV2 />;
  }
};
